import {
    Button,
    DatePicker,
    Divider,
    NumberInput,
    Select,
    SelectItem,
    TextInput,
    Textarea,
  } from "@tremor/react";
  import React, { useEffect, useState } from "react";
  import { baseURL } from "./backend/baseData";
  import axios from "axios";
  import { toast } from "react-toastify";
  import { redirect } from "react-router-dom";
  
  const CreateVisitTask = () => {
    const [formData, setFormData] = useState({
      task_name: "",
      challenge: "",
      reach_distance: "",
      latitude: "",
      longitude: "",
      player_level: 1,
      description: "",
      image: null,
      page_id: 2,
    });
    const [challenges, setChallenges] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});
  
    useEffect(() => {
      const fetchDistricts = async () => {
        try {
          const response = await axios.get(
            `${baseURL}/getInactiveChallenges.php?id=2`
          );
          if (response.status === 200 && Array.isArray(response.data)) {
            console.log(response.data);
            setChallenges(response.data);
          } else {
            console.error("Invalid response format or failed to fetch challenges");
            setChallenges([]);
          }
        } catch (error) {
          console.error("Error while fetching challenges:", error.message);
        } finally {
          setIsLoading(false);
        }
      };
  
      fetchDistricts();
    }, []);
    const handleChange = (event) => {
      const { name, value, files } = event.target;
    
      // Check if the input name is "image"
      if (name === "image") {
        // Update formData.image directly with the uploaded file
        setFormData((prevData) => ({
          ...prevData,
          image: URL.createObjectURL(files[0]), // Assuming single file upload
        }));
    
        // Update the existing image state (e.g., imageURL) to display a preview of the uploaded image
      } else {
        // For other inputs
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    };
    
    
  
    const handleSelectChange = (task_name, values) => {
      setFormData((prevData) => ({
        ...prevData,
        [task_name]: values,
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      // Validate form data
    
      const validationErrors = {};
      if (!formData.task_name.trim()) {
        validationErrors.task_name = "Task Name is required";
      }
    
      if (!formData.challenge.trim()) {
        validationErrors.challenge = "Challenge is required";
      }
      // Add validation for other fields
      
   
      if (!formData.latitude) {
        validationErrors.latitude = "Latitude are required";
      } else if (isNaN(formData.latitude)) {
        validationErrors.latitude = "Latitude must be a number";
      }
      if (!formData.longitude) {
        validationErrors.longitude = "Longitude are required";
      } else if (isNaN(formData.longitude)) {
        validationErrors.longitude = "Longitude must be a number";
      } 
      if (!formData.reach_distance) {
        validationErrors.reach_distance = "Radius are required";
      } else if (isNaN(formData.reach_distance)) {
        validationErrors.reach_distance = "Radius must be a number";
      } 
      if (!formData.player_level) {
        validationErrors.player_level = "Player Level is required";
      } else if (isNaN(formData.player_level)) {
        validationErrors.player_level = "Player Level must be a number";
      }
      if (!formData.description.trim()) {
        validationErrors.description = "Description is required";
      }
      if (!formData.image) {
        validationErrors.image = "Image is required";
      }
    
      // Add validation for other fields
    
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
    
      // If validation passes, submit the form data
      const formDataToSend = new FormData();
  
      // Append all form fields to FormData
      Object.entries(formData).forEach(([key, value]) => {
        // Append everything except image to FormData
        if (key !== 'image') {
          formDataToSend.append(key, value);
        }
      });
    
      try {
        // Fetch the image data
        const response = await fetch(formData.image);
        const blob = await response.blob();
    
        // Append image blob to FormData
        formDataToSend.append('image', blob, 'image.png');
    
        // Submit the form data
        const submitResponse = await axios.post(
          `${baseURL}/createVisitTasks.php`,
          formDataToSend,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
    
        // Handle successful submission
        console.log('Form submitted successfully:', submitResponse.data);
        const notify = () => {
          toast.success('Task Created Successfully!');
        };
        if (response.status === 200) {
        notify();
        return redirect("/challenges");
        }
      } catch (error) {
        // Handle submission error
        console.error('Error submitting form:', error.message);
      }
    };
    
    return (
      <div className="w-full  bg-[#f1f5f9]">
        <div className="w-full shadow-slate-300 ">
          {/* <div className="flex justify-end w-full p-3">
            <Link className="w-fit p-3 bg-red-600 rounded-md flex gap-3 items-center" to={"/create-challenge"}>
              <RiAddCircleLine size={20} color="white" />
              <p className="text-white">Create</p>
            </Link>
          </div> */}
        </div>
        <Divider />
        <div className="w-full p-3 ">
          <div className="w-full  mt-5 gap-2 p-3 shadow-md bg-white border border-slate-50 rounded-md">
            <h4 className="font-bold text-xl mt-2">Create Visit Task</h4>
            <form
              onSubmit={handleSubmit}
              className="grid grid-cols-12 mt-2 gap-3"
            >
              <div className="col-span-12 md:col-span-6 space-y-2">
                <h6>Task Name</h6>
                <TextInput
                  className="w-full min-h-10"
                  name="task_name"
                  value={formData.task_name}
                  onChange={handleChange}
                />
                {errors.task_name && <p className="text-red-500">{errors.task_name}</p>}{" "}
              </div>
              
             
              <div className="col-span-12 md:col-span-6 space-y-2">
                <h6>Challenge</h6>
                <Select
                  name="challenge"
                  value={formData.challenge}
                  onValueChange={(value) => handleSelectChange("challenge", value)}
                  className="min-h-10"
                >
                  {challenges.length > 0 &&
                    challenges.map((item,index) => (
                      <SelectItem value={item.challenge_id} key={index}>
                        {item.title}
                      </SelectItem>
                    ))}
                </Select>
                {errors.challenge && (
                  <p className="text-red-500">{errors.challenge}</p>
                )}{" "}
              </div>
              
              
              
              <div className="col-span-12 md:col-span-6 space-y-2">
                <h6>Player Level</h6>
                <NumberInput
                  value={formData.player_level}
                  name="player_level"
                  onChange={handleChange}
                  defaultValue={1}
                  disabled
                  className="w-full min-h-10"
                />
                {errors.player_level && <p className="text-red-500">{errors.player_level}</p>}
              </div>
              <div className="col-span-12 md:col-span-6 space-y-2">
                <h6>Radius in m</h6>
                <NumberInput
                  value={formData.reach_distance}
                  name="reach_distance"
                  onChange={handleChange}
                  className="w-full min-h-10"
                />
                {errors.reach_distance && <p className="text-red-500">{errors.reach_distance}</p>}
              </div>
              <div className="col-span-12 md:col-span-6 space-y-2">
                <h6>Latitude</h6>
                <NumberInput
                  value={formData.latitude}
                  name="latitude"
                  onChange={handleChange}
                  className="w-full min-h-10"
                />
                {errors.latitude && <p className="text-red-500">{errors.latitude}</p>}
              </div>
              <div className="col-span-12 md:col-span-6 space-y-2">
                <h6>Longitude</h6>
                <NumberInput
                  value={formData.longitude}
                  name="longitude"
                  onChange={handleChange}
                  className="w-full min-h-10"
                />
                {errors.longitude && <p className="text-red-500">{errors.longitude}</p>}
              </div>
              <div className="col-span-12 space-y-2">
                <h6>Description</h6>
                <Textarea
                  value={formData.description}
                  name="description"
                  onChange={handleChange}
                  rows={5}
                  placeholder="Type here..."
                  className="w-full min-h-10"
                />
                {errors.description && (
                  <p className="text-red-500">{errors.description}</p>
                )}
              </div>
              <div className="col-span-12 space-y-2">
                <h6>Image</h6>
                <div className="mb-3 w-96">
                  <input
                    // value={formData.image}
                    name="image"
                    onChange={handleChange}
                    className="relative m-0 block w-full min-w-0 flex-auto rounded border border-solid border-neutral-300 bg-clip-padding px-3 py-[0.32rem] text-base font-normal text-neutral-700 transition duration-300 ease-in-out file:-mx-3 file:-my-[0.32rem] file:overflow-hidden file:rounded-none file:border-0 file:border-solid file:border-inherit file:bg-neutral-100 file:px-3 file:py-[0.32rem] file:text-neutral-700 file:transition file:duration-150 file:ease-in-out file:[border-inline-end-width:1px] file:[margin-inline-end:0.75rem] hover:file:bg-neutral-200 focus:border-primary focus:text-neutral-700 focus:shadow-te-primary focus:outline-none dark:border-neutral-600 dark:text-neutral-200 dark:file:bg-neutral-700 dark:file:text-neutral-100 dark:focus:border-primary"
                    type="file"
                    accept="image/png, image/jpeg"
                    id="formFile"
                  />
                  {errors.image && <p className="text-red-500">{errors.image}</p>}
                </div>
                <div className="col-span-12 space-y-2">
                  <Button variant="primary">Submit</Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };
  
  export default CreateVisitTask;
  